import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ProductListItemDto } from './ProductListItemDto'
/**
* Class ShowcasePageBlockProductCollectionDto
*  Опубликованный блок-подборка: meta слота + превью карточек (лимит задаётся в admin-блоке).
*/
export class ShowcasePageBlockProductCollectionDto extends ActiveModel {

  /**
  * type
  *   */
  @ActiveField({ readonly: true, value: () => 'ProductCollection' })
  readonly type: string = 'ProductCollection'


/**
  * key
  * Ключ слота; уникален в рамках канала среди неудалённых.<br>Задаётся оператором; шаблон витрины запрашивает блок по этому ключу.<br>
  */
  @ActiveField('')
  key: string = ''


  /**
  * productCollectionId
  * Идентификатор подборки.  */
  @ActiveField()
  productCollectionId?: number


/**
  * sectionTitle
  * Заголовок секции; если в блоке не задан — имя подборки.<br>
  */
  @ActiveField()
  sectionTitle?: string


/**
  * @property items
  * Видимые карточки товаров (после разрешения состава подборки).  */
  @ActiveField({
    factory: [ProductListItemDto, () => undefined]
  })
  items?: Array<ProductListItemDto>
}
